import _ from 'lodash'
import qs from 'querystring'

export default {
  type: 'catalog',
  getTitle(vue) {
    return (vue.navigationMethod === 'search' ? _.get(vue.theOnlyCheckedTag, 'name_with_kind') : null) ||
      _.get(vue.kind, 'name')
  },
  getPath(vue) {
    return `/api/articles/${vue.town.id}/by_kind_id/${vue.kind_id}`
  },
  getDataOptionalQueryParams(vue) {
    const currentKindTags = vue.getKindTags(vue.kind_id)
  
    // group every tag id from the URL
    const tagIdsByType = _.groupBy(
      vue.urlTagIds,
      id => {
        const tag = _.find(currentKindTags, { id })
        return 'tag_ids_' + (tag ? tag.aggregator_tag_type_id : 'unknown')
      }
    )
  
    // make sure every tag-type of this kind is present
    _.forEach(_.uniq(_.map(currentKindTags, 'aggregator_tag_type_id')), ttId => {
      const key = 'tag_ids_' + ttId
      if (!tagIdsByType[key]) tagIdsByType[key] = []
    })
  
    return tagIdsByType
  },
  getKindTags(vue, kindId) {
    if (!kindId) {
      return []
    }

    return vue.tagsByKindId[kindId] || []
  },
  toggleTag(vue, tag) {
    let tagIds = _.clone(vue.checkedTagIds)
    tagIds[tag.id] = !vue.checkedTagIds[tag.id]
    vue.$router.push(vue.replaceInPath('tag_ids', vue.tagStringFromHash(tagIds)))
  },
  replaceInPath(vue, key, value) {
    const tagString = vue.tagStringFromHash(vue.checkedTagIds)
    const colorString = vue.tagStringFromHash(vue.checkedColors)
    let currentValues = {tag_ids: tagString, colors: colorString}
    currentValues[key] = value
    currentValues = _.pickBy(currentValues, _.identity)
    return vue.$route.path + '?' + qs.stringify(currentValues)
  },
}
